import React, { Fragment } from 'react';
import { Theme } from 'rmwc';
import { currencyFormatter } from '../Money';
import { Money } from '../Money';

export class NumericScore extends React.Component {
  render() {
    const { title, initialValue, updateValue, format, hideBenchmark, benchmark_title, benchmark_amount } = this.props;
    const getPrefix = () => {
      if (format === 'AGE') {
        return 'Age ';
      } else {
        return '';
      }
    };

    const getUpdatedValueSuffix = valueDiff => {
      if (format === 'DOLLARS_PER_YEAR') {
        return '/yr';
      } else if (format === 'AGE' && valueDiff === 1) {
        return ' year';
      } else if (format === 'AGE') {
        return ' years';
      } else {
        return '';
      }
    };

    const suffix = format === 'DOLLARS_PER_YEAR' ? '/yr' : '';

    const valueDiff = updateValue - initialValue;
    const isVisible = updateValue && valueDiff !== 0;
    const isIncreasing = updateValue && updateValue > initialValue;

    const initialValueString = format === 'AGE' ? initialValue : currencyFormatter(initialValue);
    const updateValueString = format === 'AGE' ? updateValue : currencyFormatter(updateValue);
    const valueDiffString = format === 'AGE' ? valueDiff : currencyFormatter(Math.abs(valueDiff));

    return (
      <div className="numericScore">
        <div
          className="values"
          style={{
            minHeight: this.props.shortMinHeight ? '94px' : '110px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
          }}
        >
          <div className="initialValue">
            <div>
              <span>
                {`${getPrefix()}${updateValueString ? updateValueString : initialValueString}${suffix}`}
                {isVisible && <div className={isIncreasing ? 'arrow-up' : 'arrow-down'} />}
              </span>
            </div>
            {isVisible && (
              <div>
                <p className={isIncreasing ? 'updatedGreenValue' : 'updatedRedValue'}>
                  {`${valueDiffString}${getUpdatedValueSuffix(valueDiff)}`}
                </p>
              </div>
            )}
          </div>
          {hideBenchmark || (
            <div className="benchmarks text-center">
              <Theme use="text-secondary-on-background">
                {benchmark_title}
                <div className="mt-1">
                  {format === 'DOLLARS_PER_YEAR' && (
                    <Fragment>
                      <Money amount={benchmark_amount} />
                      {suffix}
                    </Fragment>
                  )}
                  {format === 'AGE' && <span>Age {benchmark_amount}</span>}
                </div>
              </Theme>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default NumericScore;
